<template>
    <div>
        <hd-header></hd-header>
        <div style="width: 400px;position: relative;" :style="{top:mainTop+'px', left:mainLeft+'px'}" ref="mainDiv">
            <div style="font-size: 24px;">设置新密码</div>
            <span style="font-size: 14px;color: #999999;">不可与之前设置过的密码重复</span>
            <div style="margin-top: 60px;">
                <el-form :model="form" ref="refForm">
                    <el-form-item label="" prop="password" :rules="[{
                required: true,
                message: '请输入新密码',
                trigger: 'blur'
            },{
                min: 6,
                max: 20,
                message: '密码长度6-20位，建议数字和字母组合',
                trigger: 'blur'
            }]">
                        <el-input placeholder="输入新密码" prefix-icon="iconfont icon-key" v-model="form.password"
                                  type="password"></el-input>
                    </el-form-item>
                    <el-form-item label="" prop="repeatPassword" :rules="[{
                required: true,
                message: '请重复输入新密码',
                trigger: 'blur'
            },{
                min: 6,
                max: 20,
                message: '密码长度6-20位，建议数字和字母组合',
                trigger: 'blur'
            }]">
                        <el-input placeholder="重复输入新密码" prefix-icon="iconfont icon-key"
                                  v-model="form.repeatPassword" type="password"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div class="divInput">
                <el-button type="primary" style="width: 100%;" @click="resetPwd">重置密码</el-button>
            </div>
        </div>
        <hd-footer></hd-footer>
    </div>
</template>

<script>
import HdHeader from '../public/Header'
import HdFooter from '../public/FooterLogined'

export default {
    name: 'SetNewPassword',
    components: {
        HdHeader,
        HdFooter
    },
    created () {
        let cert = localStorage.getItem('getBackCert')
        if (this.isEmpty(cert)) {
            //非法请求
            this.$router.push({
                path: '/'
            })
        } else {
            this.cert = cert
        }
    },
    mounted () {
        this.$nextTick(function () {
            this.setPanelPosition()
        })
    },
    data () {
        return {
            mainTop: 0,
            mainLeft: 0,
            form: {
                password: '',
                repeatPassword: ''
            },
            cert: ''
        }
    },
    methods: {
        setPanelPosition () {
            let h = this.$refs.mainDiv.offsetHeight
            this.mainTop = this.getClientTop(h)
            this.mainLeft = (window.screen.availWidth - 400) / 2
        },
        resetPwd () {
            let that = this
            this.$refs.refForm.validate((valid) => {
                if (valid) {
                    if (that.isEmpty(this.form.password)) {
                        that.showError('请输入新密码')
                        return
                    }
                    if (that.form.password.length < 6 || that.form.password.length > 20) {
                        that.showError('密码长度在6~20之间')
                        return
                    }
                    if (that.isEmpty(that.form.repeatPassword)) {
                        that.showError('请再次输入新密码')
                        return
                    }
                    if (that.form.password !== that.form.repeatPassword) {
                        that.showError('两次密码不一致')
                        return
                    }
                    that.$ajax.post('/api/user/resetpassword', {
                        cert: that.cert,
                        password: that.form.password
                    }).then(function (r) {
                        //删除cert
                        localStorage.removeItem('getBackCert')
                        setTimeout(function () {
                            that.$router.push({
                                path: '/'
                            })
                        }, 3000)
                    })
                }
            })
        }
    }
}
</script>

<style scoped>
.divInput {
    padding-top: 1em;
    padding-bottom: 1em;
}
</style>



// WEBPACK FOOTER //
// src/components/login/SetNewPassword.vue